<template>
  <div class="qualifications-editor">
    <h4><b>{{name}}</b></h4>
    <p class="text-muted">{{description}}</p>
    <b-row
      v-for="(qualification, index) in qualifications"
      :key="`${index}-qualification`"
    >
      <b-col cols="8">
        <b-form-group label="Qualification Name">
          <multiselect
            :value="qualification.name"
            @input="onNameChange($event, index)"
            :options="qualificationTypes"
            :multiple="false"
            :group-select="false"
            placeholder="e.g.: Bachelor Degree"
            class="multiselect-rlnx"
          >
            <template v-slot:noResult>Qualification not found, try something similar</template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col :cols="index > 0 ? 3 : 4">
        <b-form-group label="Date">
          <date-picker
            :value="qualification.date"
            @input="onDateChange($event, index)"
            type="month"
            lang="en"
            format="MMM YYYY"
            input-class="mx-input mx-dimensions"
            confirm
          />
        </b-form-group>
      </b-col>
      <b-col v-if="index > 0" cols="1" class="d-flex justify-content-center pt-3">
        <span
          @click="onDeleteQualification(index)"
          class="delete-button mt-4 pt-1"
        ><font-awesome-icon icon="trash-alt"/></span>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <span
          @click="onAddQualification"
          :style="{ cursor: addQualificationButtonActive ? 'pointer' :  'default' }"
        >
          <b-button
            variant="primary"
            class="mr-1"
            style="line-height: 1.33"
            :disabled="!addQualificationButtonActive"
            pill
          >+</b-button>
          <b :class="{ 'text-muted': !addQualificationButtonActive }">Add another qualification</b>
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'JobTitleSelector',
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      type: Array,
      default: () => [],
    },
    qualificationTypes: {
      type: Array,
      default: () => [
        'GCSE Grades D-G', 'GCSE Grades A*-C,', 'A-level', 'Certificate of Higher Education', 'Diploma of Higher Education', 'Foundation Degree',
        'Bachelor\'s Degree without honours', 'Bachelor\'s degree with honours', 'Master\'s degree,', 'Postgraduate Certificate', 'Doctorate',
        'PhD', 'Professional Doctorate', 'RQF level 8',
      ],
    }
  },
  data: () => ({
    fatalErr: null,
    err: null,
  }),
  computed: {
    qualifications() {
      const defaultQualifications = [ {
        name: '',
        date: null,
      } ];
      return Array.isArray(this.value) && this.value.length ? this.value : defaultQualifications;
    },
    addQualificationButtonActive() {
      if (Array.isArray(this.value) && this.value.length) {
        return this.value.reduce((bool, { name, date }) => bool && name && date, true);
      }
      return false;
    },
  },
  methods: {
    onNameChange(name, index) {
      const value = Array.isArray(this.value) ? this.value : [];
      if (value[index]) {
        value[index].name = name;
      } else {
        value.push({ name, date: '' });
      }
      this.$emit('input', value);
    },
    onDateChange(date, index) {
      const value = Array.isArray(this.value) ? this.value : [];
      if (value[index]) {
        value[index].date = date;
      } else {
        value.push({ name: '', date });
      }
      this.$emit('input', value);
    },
    onAddQualification() {
      if (this.addQualificationButtonActive) {
        const value = this.value;
        value.push({ name: '', date: '' });
        this.$emit('input', value);
      }
    },
    onDeleteQualification(index) {
      const value = this.value;
      value.splice(index, 1);
      this.$emit('input', value);
    }
  },
};
</script>

<style lang="scss">
.qualifications-editor {
  .delete-button {
    color: #333;
    cursor: pointer;
    opacity: .75;

    &:hover {
      opacity: 1;
    }
  }
  .mx-datepicker {
    width: 100%;
    .mx-input {

      &.mx-dimensions {
        height: 38px;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/QualificationsEditor.vue